/** @jsxImportSource @emotion/react */
import { SerializedStyles } from '@emotion/react';

import { downloadBlob } from '@/Client/Lib';
import { getDeoptimizedScan, type ScanRootOptimized } from '@kaiizen/kai-scan-template-system';
import { DownloadIcon } from '@kaiizen/kai-shiki/react';
import ConsoleIcon from '@mui/icons-material/Code';
import { MAIN_NAVIGATION_BUTTON_STYLES } from './mainNavigationStyles';

export const DebugButtonsHeaderAction = ({
  buttonStyle = MAIN_NAVIGATION_BUTTON_STYLES.debug,
  scanRoot,
  scanName,
}: {
  buttonStyle?: SerializedStyles;
  scanRoot: ScanRootOptimized;
  scanName?: string;
}) => (
  <>
    <div
      key={'download-deoptimized-scan'}
      onClick={() => {
        const deoptimizedScan = getDeoptimizedScan(scanRoot);
        const dataStr = JSON.stringify(deoptimizedScan, null, 2);
        downloadBlob(new Blob([dataStr], { type: 'application/json' }), `${scanName || 'scan'}-deoptimized.json`);
      }}
      css={buttonStyle}
      title={'Download de-optimized scan as JSON'}
    >
      <DownloadIcon size={20} />
    </div>
    <div
      key={'log-deoptimized-scan'}
      onClick={() => {
        const deoptimizedScan = getDeoptimizedScan(scanRoot);
        console.log('Deoptimized scanRoot:', deoptimizedScan);
        (window as any).scanRoot = scanRoot;
        (window as any).deoptimizedScan = deoptimizedScan;
        console.log('Template:', scanRoot.template);
        (window as any).template = scanRoot.template;
        console.log(`window.scan = deoptimizedScan\nwindow.deoptimizedScan = deoptimizedScan`);
      }}
      css={buttonStyle}
      title={'Log de-optimized scan to console and set window.scan'}
    >
      <ConsoleIcon fontSize={'small'} />
    </div>
  </>
);
